import Lazyload from 'vue-lazyload';
export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.12.25@vant/es/lazyload/index.js
// module id = 301
// module chunks = 38